module.exports = "mat-dialog-content {\n  display: flex;\n  flex-direction: column; }\n\nmat-dialog-content > * {\n  width: 60%; }\n"